const initColorSwatches = () => {
    let colorSwatches = document.querySelectorAll('.color-swatch');                      
    const defaultColor = document.querySelector('.default-swatch').dataset.colorSwatchValue;

    colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseover', (e) => {
        let currentValue = swatch.dataset.colorSwatchValue;
        document.getElementById("color-swatch-value").innerText = currentValue;
        });

        swatch.addEventListener('mouseout', (e) => {          	
        document.getElementById("color-swatch-value").innerText = defaultColor;
        });

        swatch.addEventListener('click', (e) => {
        if (swatch.classList.contains('current-swatch')) {
            e.preventDefault();
        }      
        });
    });
}